import { createFormHook, createFormHookContexts } from "@tanstack/react-form";

import MultiCheckbox from "./components/fields/checkbox/MultiCheckbox";
import SingleCheckbox from "./components/fields/checkbox/SingleCheckbox";
import DateField from "./components/fields/dates/DateField";
import FileCard from "./components/fields/files/FileCard";
import FileUpload from "./components/fields/files/FileUpload";
import BooleanRadioButton from "./components/fields/radio/BooleanRadioButton";
import RadioButton from "./components/fields/radio/RadioButton";
import YesNoRadioButton from "./components/fields/radio/YesNoRadioButton";
import AutocompleteSelect from "./components/fields/select/AutocompleteSelect";
import ColorButtonSelect from "./components/fields/select/ColorButtonSelect";
import MultiAutocompleteSelect from "./components/fields/select/MultiAutocompleteSelect";
import MultiSelect from "./components/fields/select/MultiSelect";
import SelectField from "./components/fields/select/Select";
import ToggleGroupSelect from "./components/fields/select/ToggleGroupSelect";
import HtmlEditor from "./components/fields/text/HtmlEditor";
import SearchBar from "./components/fields/text/SearchBar";
import TextInput from "./components/fields/text/TextInput";
import FilterButtons from "./components/layout/FilterButtons";
import FormSection from "./components/layout/FormSection";
import ClearableRadioGroup from "./components/sidebarFilters/ClearableRadioGroup";

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

// lets keep these alphabetical for easy lookup as this grows
export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    AutocompleteSelect,
    BooleanRadioButton,
    ColorButtonSelect,
    ClearableRadioGroup,
    DateField,
    FileCard,
    FileUpload,
    HtmlEditor,
    MultiAutocompleteSelect,
    MultiCheckbox,
    MultiSelect,
    RadioButton,
    SearchBar,
    SelectField,
    SingleCheckbox,
    TextInput,
    ToggleGroupSelect,
    YesNoRadioButton,
  },
  formComponents: {
    FormSection,
    FilterButtons,
  },
});

export type AppFormType = ReturnType<typeof useAppForm>;
export type AppFieldType = ReturnType<typeof useFieldContext>;
